<template>
  <div>
    <v-divider v-if="atLeastOneEntryWithTimeframe" />
    <v-list-tile v-if="atLeastOneEntryWithTimeframe">
      <v-list-tile-title class="menu-item">
        <strong class="msr--text">{{ $t('filterByTimeframe') }}</strong>
      </v-list-tile-title>
    </v-list-tile>
    <v-list-tile
      v-for="timeframe in timeframes"
      :key="'timeframe_' + timeframe.id"
      :value="
        selectedTimeframes.length > 0 &&
          selectedTimeframeIds.includes(timeframe.id)
      "
      data-cy="timeframe-filter-list-tile"
      @click="onTimeframeClicked(timeframe)"
    >
      <v-list-tile-content>
        <template v-if="timeframe.name">
          <v-list-tile-title>
            {{ timeframe.name }}
          </v-list-tile-title>
          <v-list-tile-sub-title>
            {{ describeWeekdays(timeframe.weekdays) }}: {{ timeframe.start }} -
            {{ timeframe.end }}
          </v-list-tile-sub-title>
        </template>
        <template v-else>
          <v-list-tile-title>
            {{ describeWeekdays(timeframe.weekdays) }}: {{ timeframe.start }} -
            {{ timeframe.end }}
          </v-list-tile-title>
        </template>
      </v-list-tile-content>
    </v-list-tile>
  </div>
</template>

<script>
import orderBy from 'lodash.orderby';

import {describeWeekdays} from '@/mixins/weekdays';
import selectedTimeframes from '@/mixins/selectedTimeframes.js';

export default {
  mixins: [selectedTimeframes],
  props: {
    entries: {
      type: Array[Object],
      required: true,
    },
  },
  computed: {
    entriesWithTimeFrames() {
      return this.entries.filter(
        (entry) => entry.timeframes && entry.timeframes.length > 0
      );
    },
    atLeastOneEntryWithTimeframe() {
      return this.entriesWithTimeFrames.length > 0;
    },
    /** Unique list of timeframes as taken from entries, sorted by start. */
    timeframes() {
      let uniqueTimeframes = [];
      let uniqueTimeframeIds = [];
      for (var i = 0; i < this.entriesWithTimeFrames.length; i++) {
        const entry = this.entriesWithTimeFrames[i];
        for (const timeframe of entry.timeframes || []) {
          if (uniqueTimeframeIds.indexOf(timeframe.id) === -1) {
            uniqueTimeframeIds.push(timeframe.id);
            uniqueTimeframes.push(timeframe);
          }
        }
      }
      return orderBy(uniqueTimeframes, 'start');
    },
  },
  methods: {
    describeWeekdays: describeWeekdays,
    onTimeframeClicked(timeframe) {
      if (
        this.selectedTimeframeIds.length > 0 &&
        this.selectedTimeframeIds.includes(timeframe.id)
      ) {
        this.removeSelectedTimeframe(timeframe);
      } else {
        this.addSelectedTimeframe(timeframe);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TimeframeFilterListTile.vue